import { isUnauthenticatedError } from "@punto/frontend-shared/utils/error-utils";

/** React Query's own default. */
const MAX_RETRIES = 3;

/**
 * The app-wide query retry, set by `QueryClientProvider`. openapi-react-query
 * throws the API's error body, which carries `statusCode`. A 401 means the
 * request had no valid token; sending it again with the same one cannot
 * succeed, and the retries only keep the app waiting (P-3142).
 */
export const retryQuery = (failureCount: number, error: unknown): boolean =>
  !isUnauthenticatedError(error) && failureCount < MAX_RETRIES;
